import { Navigate } from 'react-router-dom';

export const redirects = {
  // '/android': 'https://play.google.com/store/apps/details?id=com.tinycloud.app.muse',
  '/whitepaper': 'https://github.com/TinyCloudLabs/whitepaper/blob/main/README.md',
  '/android': 'https://forms.gle/jMSJH75GfeSp9iG98',
  '/ios': 'https://apps.apple.com/us/app/muse-voice-notes/id6738095687',
  '/world': 'https://world.org/mini-app?app_id=app_0411bde5412fe557a6551a15a15f38b2',
  '/tg': 'https://t.me/+mZW0NaAG1oswMzUx',
  '/ios-dev': 'https://testflight.apple.com/join/UrtvpNMn',
  '/deck': 'https://tinycloud-deck.pages.dev',
  '/memo': 'https://memo.tinycloud.xyz',
  '/meet-team': 'https://cal.com/team/tinycloud/intro',
  '/meet-sam': 'https://cal.com/samgbafa/intro',
  '/meet-sam-private': 'https://cal.com/samgbafa/meeting',
  '/sozu-hack': 'https://youtube.com/shorts/k23K9TOdxdA?feature=share',
  '/overview': 'https://technology-map.pages.dev',

  // Add more redirects as needed
};

export const Redirect = () => {
  // Get the current path
  const path = window.location.pathname;

  // Check if we have a redirect for this path
  const destination = redirects[path];

  if (destination) {
    // For external URLs, we need to use window.location
    window.location.href = destination;
    return null;
  }

  // If no redirect is found, navigate to home or show a 404
  return <Navigate to="/404" replace />;
};

export default Redirect;
